export default {
  add: 'Pridať klienta',
  countOfAnimals: 'Počet zvierat',
  degree: 'Titul',
  firstName: 'Meno',
  fullName: 'Meno a priezvisko',
  lastName: 'Priezvisko',
  createdAt: 'Dátum vytvorenia',
  company: {
    address: 'Adresa firmy',
    hasCompany: 'Klient zastupuje firmu',
    info: 'Informácie o firme',
    name: 'Názov firmy'
  },
  gender: {
    gender: 'Pohlavie',
    male: 'Muž',
    female: 'Žena'
  },
  profile: {
    addAnimal: 'Pridať zviera | Pridať zvieratá',
    assignAnimal: 'Priradiť zviera | Priradiť zvieratá',
    notAssignedAnimals: 'Nepriradené zvieratá'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/sk/client.js